import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {AuthService} from '../ngrx/main/auth.service';
import {configApp} from '../configapp/config';


@Injectable()
export class AuthInterceptor implements HttpInterceptor {

	private AUTH_HEADER = 'Authorization';
	private tokenApp = configApp.tokenApp;

	constructor(private auth: AuthService) {

	}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

		// récupérer token de l'utilisateur via local/
		const loginLocal = this.auth.recupererLoginDuLocal();
		let newUrl = req.url;
		if(! req.url.includes('https://')) {
			if (req.url.includes('app/auth/')) {
				newUrl = configApp.urlBase + req.url;
				// inclure token app
				req = req.clone({headers: req.headers.set(this.AUTH_HEADER, this.tokenApp)});
				req = req.clone({url: newUrl});
			}
			else {
				// inclure token user
				if (req.url.includes('api/')) {

					if (req.url.includes('api/{db}')) {
						// Appel entities de la base générale
						newUrl = configApp.urlBase + newUrl.replace('{db}', loginLocal.dossier);
						req = req.clone({url: newUrl});
					} else {
						// Appel entities de la base générale
						newUrl = configApp.urlBase + req.url;
						req = req.clone({url: newUrl});
					}
				}

				req = req.clone({headers: req.headers.set(this.AUTH_HEADER, 'Bearer ' + loginLocal.token)});
				req = req.clone({params: req.params.append('uid', loginLocal.uid)});

			}
		}

		return next.handle(req);

	}

}
